<template>
    <v-container>
        <div v-if="hasPermission('MIETSPIEGEL_BACKEND_WRITE_BERECHNUNGSVORLAGE')" class="d-flex justify-left my-3">
            <v-btn v-on:click="save" outlined large color="indigo" aria-labelled-by="Speichern"><span class="black--text subtitle-1">Speichern</span></v-btn>
        </div>
        <div class="my-3">
            <h1 class="uiTitle header">
                Haustypen
            </h1>
        </div>
        <div class="mb-5">
            <div class="d-flex flex-column grey lighten-3 font-weight-bold errors" role="alert" v-if="haustyp">
                <div>
                    <v-icon style="color:#c50517">mdi-alert</v-icon>
                    <strong class="red--text">Konflikt!</strong>
                </div>
                <span class="red--text" v-html="getConflictText()"></span>
                <br/>
                <span class="red--text">Bitte ändern Sie Ihre Eingabe.</span>
            </div>
            <p class="validationError" role="alert" v-if="validationError">
                <v-icon style="color:#c50517">mdi-alert</v-icon><strong>Bitte wählen Sie eine Option aus!</strong>
            </p>
            <v-card class="d-flex justify-center"
                outlined
            >
                <v-list class="py-0" style="width:100%" role="group">
                    <v-list-item-group role="list" tabindex="0" :aria-active-descendant="selectedItem" v-model="selectedItem" color="transparent" active-class="list-selected" >
                        <template v-for="(item, index) in items">
                            <v-divider
                                v-if="item.divider"
                                :key="index"
                                aria-hidden="true"
                            ></v-divider>
                            <v-list-item
                                v-else
                                :key="index"
                                tabindex="-1"
                                :id="item.id"
                                v-on:dblclick="selectAndNext(item.id)"
                            >
                                <input class="d-flex justify-center" @focus="focusInputParent" type="radio" tabindex="-1" :checked="isSelected(item.id)" :title="$t('haustyp.' + item.id)">
                                <div class="d-flex flex-column" :style="getColor(item.id)" v-if="hasError(item.error)">
                                    <strong v-if="isSelected(item.id)">Konflikt!</strong>
                                    <strong v-else>Warnung!</strong>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-icon :style="getColor(item.id)" v-on="on">mdi-alert</v-icon>
                                        </template>
                                        <span :aria-labelled-by="getErrorText(item.errorTypes, item.error, item.id)" v-html="getErrorText(item.errorTypes, item.error, item.id)"></span>
                                    </v-tooltip>
                                </div>
                                <v-list-item-content aria-hidden="true" style="color: black; margin-left: 8px">
                                    <v-list-item-title :class="(hasError(item.error) ? 'conflictGrey': '')" v-html="$t('haustyp.' + item.id)"></v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-list-item-group>
                </v-list>
            </v-card>
        </div>
        <!-- BUTTON SECTION -->
        <div class="d-flex justify-center justify-space-around my-3">
            <v-btn v-on:click="back" outlined large color="indigo" aria-labelled-by="Zurück"><span class="black--text subtitle-1">Zurück</span></v-btn>
            <v-btn v-on:click="next" outlined large color="indigo" aria-labelled-by="Weiter"><span class="black--text subtitle-1">Weiter</span></v-btn>
        </div>
        <!-- INFO SECTION -->
        <div>
            <v-card class="d-flex justify-center mt-6" outlined color="indigo" hover>
                <v-expansion-panels>
                    <v-expansion-panel ref="infoPanel">
                        <v-expansion-panel-header @click="changedExpansion" v-if="expanded" aria-label="Info-Bereich Schließen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-header @click="changedExpansion" v-else aria-label="Info-Bereich Öffnen" role="heading" aria-level="2" class="subtitle-1 py-1">Info</v-expansion-panel-header>
                        <v-expansion-panel-content>
                            <h3>Haustypen</h3><br/>
                            <p>
                                (genau einer der fünf Haustypen muss gewählt werden)<br/>
                                <b>Hinweis:</b> Zur Beurteilung der Frage, ob ein vorhandener Speicher/Dachboden 
                                zu Wohnzwecken nicht oder nur teilweise ausgebaut wurde, kommt es auf einen 
                                vorhandenen Spitzboden/Dachspitz nicht an.
                            </p>
                            <h3>Sehr einfacher Altbau</h3><br/>
                            <p>
                                Wohnung in einem Gebäude mit einem Baujahr vor 1949 und einem vorhandenen, aber 
                                zu Wohnzwecken nicht oder nur teilweise ausgebauten Speicher/Dachboden. Die 
                                Wohnung verfügt nicht über Stuck an Wand und/oder Decke, die Höhe der Wohnräume 
                                ist höchstens 2,90m und der größte Wohnraum hat eine Fläche von höchstens 20m².
                            </p>

                            <h3>Einfacher Altbau</h3><br/>
                            <ol>
                                <li>
                                    <strong>Wohnung in einem Gebäude mit einem Baujahr vor 1949 und einem vorhandenen, aber
                                    zu Wohnzwecken nicht oder nur teilweise ausgebauten Speicher/Dachboden.</strong> 
                                    Die Wohnung verfügt über mindestens eines der drei Merkmale: Stuck an Wand 
                                    und/oder Decke, die Höhe des größten Wohnraums ist über 2,90m oder die Fläche 
                                    des größten Wohnraums ist größer als 20m².
                                </li>
                                <li>
                                    <strong>Wohnung in einem Gebäude mit einem Baujahr vor 1949, bei dem ein vorhandener
                                    Speicher/Dachboden vollständig ausgebaut oder kein Speicher/Dachboden vorhanden
                                    ist.</strong> Die Wohnung verfügt nicht über Stuck an Wand und/oder Decke, 
                                    die Höhe der Wohnräume ist höchstens 2,90m und der größte Wohnraum hat eine 
                                    Fläche von höchstens 20m².
                                </li>
                            </ol><br/>

                            <h3>Guter Altbau</h3><br/>
                            <p>
                                Wohnung in einem Gebäude mit einem Baujahr vor 1949, bei dem ein vorhandener 
                                Speicher/Dachboden vollständig ausgebaut oder kein Speicher/Dachboden vorhanden 
                                ist. Die Wohnung verfügt über mindestens eines der drei Merkmale: Stuck an Wand 
                                und/oder Decke, die Höhe des größten Wohnraums ist über 2,90m oder die Fläche 
                                des größten Wohnraums ist größer als 20m².
                            </p>
                            <p>
                                Im Zweifel ist für die Raumhöhe die höchste Stelle des
                                größten Wohnraums maßgeblich (Bad, Flur, WC und (Wohn-)Küche bleiben außer 
                                Betracht). Dachschrägen werden nicht berücksichtigt. Stuck ist vorhanden, wenn 
                                die Wohnung an mindestens einer Stelle über Stuck an Wand oder Decke verfügt.
                            </p>

                            <h3>Einfacher Nachkriegsbau</h3><br/>
                            <p>
                                Wohnung in einem Gebäude mit einem Baujahr nach 1948 und vor 1978 und einem 
                                vorhandenen, aber zu Wohnzwecken nicht oder nur teilweise ausgebauten 
                                Speicher/Dachboden.
                            </p>

                            <h3>Anderer Haustyp</h3><br/>
                            <p>
                                Wohnung in einem Gebäude mit einem Baujahr nach 1948, welche nicht unter das 
                                Merkmal „Einfacher Nachkriegsbau“ fällt.
                            </p>

                            <h3>Hinweise zur Einordnung von Wohnungen in Gebäuden mit Baujahr vor 1949</h3><br>
                            <p><strong>Altbauten unterscheiden sich bezüglich zweier Parameter:</strong><br><br><br>

                                <strong>Ausbau des Speichers/Dachbodens:</strong><br>
                                Auf einen vorhandenen Spitzboden/Dachspitz kommt es nicht an.
                            <ul>
                                <li>
                                    Nicht oder teilweise ausgebauter Speicher/Dachboden.
                                </li>
                                <li>
                                    Speicher/Dachboden vollständig zu Wohnzwecken ausgebaut oder nicht vorhanden.
                                </li>
                            </ul><br/>

                            <strong>Drei für Altbauten typische Stilelemente:</strong>
                            <ul>
                                <li>
                                    Stuck an Wand und/oder Decke. Dabei ist es ausreichend, wenn an mindestens einer
                                    Stelle der Wohnung an Wand oder Decke Stuck vorhanden ist.
                                </li>
                                <li>
                                    Die Fläche des größten Wohnraums ist größer als 20m².
                                </li>
                                <li>
                                    Die Höhe des größten Wohnraums ist über
                                    2,90m. Im Zweifel ist für die Raumhöhe die höchste Stelle des größten Wohnraums
                                    maßgeblich (Bad, Flur, WC und (Wohn-)Küche bleiben außer Betracht). Dachschrägen
                                    werden nicht berücksichtigt.
                                </li>
                            </ul><br/>
                            </p>
                            <p><strong>
                                Wohnungen in Gebäuden mit Baujahr vor 1949 lassen sich nach folgendem Schema einordnen:
                            </strong></p>
                            <table class="zuAbschlaege" data-role="table" data-mode="reflow">
                                <thead>
                                <tr>
                                    <th class="whiteTable"></th>
                                    <th class="whiteTable">Ohne eines der<br> genannten Stilelemente</th>
                                    <th class="whiteTable">Mit mindestens<br> einem der genannten Stilelemente</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td class="whiteTable"> <strong>Speicher/Dachboden nicht oder teilweise zu Wohnzwecken ausgebaut</strong> </td>
                                    <td class="whiteTable"> Sehr einfacher Altbau</td>
                                    <td class="whiteTable"> Einfacher Altbau</td>
                                </tr>
                                <tr>
                                    <td class="whiteTable"> <strong>Speicher/Dachboden vollständig zu Wohnzwecken ausgebaut oder nicht vorhanden</strong> </td>
                                    <td class="whiteTable"> Einfacher Altbau</td>
                                    <td class="whiteTable"> Guter Altbau</td>
                                </tr>
                                </tbody>
                            </table><br/>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </v-card>
        </div>
    </v-container>
</template>

<script>
    import {Component, Vue} from 'vue-property-decorator';
    import { EventBus } from '../eventbus';
    import { mapActions, createNamespacedHelpers } from 'vuex';

    const { mapMutations, mapState } = createNamespacedHelpers('error')
    const { mapGetters } = createNamespacedHelpers('user')

    @Component({
        // don't get confused, this is a haustyp ERROR
        computed: { ...mapState(['haustyp']),
                    ...mapGetters(['hasPermission'])},
        methods: { ...mapActions('berechnung', ['SELECT_HAUSTYP']),
                    ...mapActions('error', ['CHECK_BAUJAHR_ERROR']),
                    ...mapActions('error', ['CHECK_MODERNISIERTEFENSTER_ERROR']),
                    ...mapMutations(['SET_HAUSTYP_ERROR']) }
    })
    export default class Haustypen extends Vue {

         get error(){
             return this.hasError(this.selectedData.error)
         }

         get selectedData(){
             return this.items.filter(item => item.id === this.selectedItem)[0]
         }

        data() {
            return {
                index: 6,
                selectedItem: this.$store.state.berechnung.selectedHaustyp,
                items: [
                    { id: 0,
                      error: {
                          selectedBaujahr: function(el){ return el > 2 }
                      },
                      errorTypes: [
                          "Baujahr"
                      ]
                    },
                    { divider: true},
                    { id: 1,
                      error: {
                          selectedBaujahr: function(el){ return el > 2 }
                      },
                      errorTypes: [
                          "Baujahr"
                      ]
                    },
                    { divider: true},
                    { id: 2,
                      error: {
                          selectedBaujahr: function(el){ return el > 2 }
                      },
                      errorTypes: [
                          "Baujahr"
                      ]
                    },
                    { divider: true},
                    { id: 3,
                      error: {
                          selectedBaujahr: function(el){ return (el < 3 && el != null) || el > 4 },
                          selectedModernisierteFenster: function(el){return el == 0}
                      },
                      errorTypes: [
                          "Baujahr",
                          "ModernisierteFenster"
                      ],
                    },
                    { divider: true},
                    { id: 4,
                      error: {
                          selectedBaujahr: function(el){ return el < 3 }
                      },
                      errorTypes: [
                          "Baujahr"
                      ]},
                ],
                validationError: false,
                expanded: false
            };
        }

        focusInputParent(event){
            //only triggered by screenreader
            event.target.parentElement.focus()
            event.preventDefault()
        }

        changedExpansion(event){
            this.expanded = !this.expanded
            event.currentTarget.setAttribute('aria-expanded', this.expanded)
        }

        isSelected(index) {
            return index == this.selectedItem;
        }

        selectAndNext(id) {
            this.$data.selectedItem = id;
            this.next();
        }

        hasError(error){
            /*
             * check if function in error for selected attribute (of different component) matches
             * the stored value (of the different component in the state)
             */
            return error && Object.keys(error).map(key => error[key](this.$store.state.berechnung[key])).some(el => el === true)
        }

        getErrorText(errorTypes, error, id){
            /*
             * select those errorTypes (= different components), whose selected value
             * in the store is matched by the function at the same index in error (of the item)
             */
            let errorType = errorTypes.filter((_, i) => error[Object.keys(error)[i]](this.$store.state.berechnung[Object.keys(error)[i]]));
            return errorType.map(el => this.$t('warning.select',
                { step: this.$t(el),
                  choice: this.$t(el.charAt(0).toLowerCase() + el.substring(1) + '.' +
                          this.$store.state.berechnung['selected' + el]),
                  currentStep: "des Haustyps ",
                  currentChoice: this.$t('haustyp.' + id)
                })).join("<br/>");
        }

        //when conflict is present its text is depending on the item in the store, not the current selection
        getConflictText(){
            let conflictItem = this.items.filter(item => item.id === this.$store.state.berechnung.selectedHaustyp)[0]
            return this.getErrorText(conflictItem.errorTypes, conflictItem.error, conflictItem.id)
        }

        mounted() {
            EventBus.$emit('scroll', this.$data.index)
            this.$refs.infoPanel.$el.firstChild.setAttribute('aria-expanded', false)
            var vm = this;
            const listgroup = document.querySelector('[role="group"]').firstChild
            listgroup.addEventListener('focus', event => {
                event.target.firstChild.focus()
            })
            //item group handling: (un)select on spacebar
            listgroup.addEventListener('keydown', event => this.itemSelection(event, vm))
        }

        itemSelection(event, vm){
            if(event.key !== ' ') return
            const option = event.target.closest('.v-list-item')
            if (!option) return
            const id = parseInt(option.id)
            if(vm.selectedItem === id){
                setTimeout(function(){
                    vm.selectedItem = null
                }, 100)
            }else{
                setTimeout(function(){
                    vm.selectedItem = id
                }, 100)
            }
            event.preventDefault()
        }

        save() {
            EventBus.$emit('getSaveData', this.index)
        }

        next() {
            this.validationError = (this.selectedItem == undefined || this.selectedItem == null);
            if(this.validationError) {
                let alert = document.querySelector('.validationError')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
                return;
            }
            console.log(this.selectedData.id)
            this.SELECT_HAUSTYP({ selectedHaustyp: this.selectedItem, selectedHaustypError: this.selectedData.error })
            this.CHECK_BAUJAHR_ERROR()
            this.CHECK_MODERNISIERTEFENSTER_ERROR()
            if(this.error){
                console.log('found haustyp error')
                this.SET_HAUSTYP_ERROR(true)
                let alert = document.querySelector('.errors')
                alert.removeAttribute('role')
                alert.setAttribute("role", "alert")
            } else {
                this.SET_HAUSTYP_ERROR(false)
                this.$router.push('heizung')
            }
        }

        back() {
            this.$router.push('gebaeudetyp')
        }

        getColor(index){
            if(this.isSelected(index)){
                return "color:#c50517";
            }
            return "color:blue";
        }
    }
</script>
